export default __webpack_public_path__ + "static/media/track-sales-img-homepage.f3d929b6.png";